// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CaseHomeHealthAgencyRelationshipModel } from './caseHomeHealthAgencyRelationshipModel.js';
import type { CasePayorRelationshipModel } from './casePayorRelationshipModel.js';
import type { CasePrescriptionRelationshipModel } from './casePrescriptionRelationshipModel.js';
import type { CaseRelationshipModel } from './caseRelationshipModel.js';
import type { TrialcardCaseV3ModelsCaseDocumentRelationshipModel } from './trialcardCaseV3ModelsCaseDocumentRelationshipModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Model for relationships associated with a Case or Workflow.
*/
export class ICaseRelationships {
    'prescribers': Array<CaseRelationshipModel> | null;
    'prescriptions': Array<CasePrescriptionRelationshipModel> | null;
    'sites': Array<CaseRelationshipModel> | null;
    'payors': Array<CasePayorRelationshipModel> | null;
    'pharmacies': Array<CaseRelationshipModel> | null;
    'homeHealthAgencies': Array<CaseHomeHealthAgencyRelationshipModel> | null;
    'documents': Array<TrialcardCaseV3ModelsCaseDocumentRelationshipModel> | null;
    'notes': Array<number> | null;
    'tasks': Array<number> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof ICaseRelationships>> = [
        {
            "name":     "prescribers",
            "baseName": "prescribers",
            "type":     "Array<CaseRelationshipModel>"
        },
        {
            "name":     "prescriptions",
            "baseName": "prescriptions",
            "type":     "Array<CasePrescriptionRelationshipModel>"
        },
        {
            "name":     "sites",
            "baseName": "sites",
            "type":     "Array<CaseRelationshipModel>"
        },
        {
            "name":     "payors",
            "baseName": "payors",
            "type":     "Array<CasePayorRelationshipModel>"
        },
        {
            "name":     "pharmacies",
            "baseName": "pharmacies",
            "type":     "Array<CaseRelationshipModel>"
        },
        {
            "name":     "homeHealthAgencies",
            "baseName": "homeHealthAgencies",
            "type":     "Array<CaseHomeHealthAgencyRelationshipModel>"
        },
        {
            "name":     "documents",
            "baseName": "documents",
            "type":     "Array<TrialcardCaseV3ModelsCaseDocumentRelationshipModel>"
        },
        {
            "name":     "notes",
            "baseName": "notes",
            "type":     "Array<number>"
        },
        {
            "name":     "tasks",
            "baseName": "tasks",
            "type":     "Array<number>"
        },
    ];

    static getAttributeTypeMap() {
        return ICaseRelationships.attributeTypeMap;
    }
}
